var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header"},[(_vm.title.secondTitle)?_c('div',{staticClass:"second-title title-box"},[_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.title.secondTitle)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }